export default __webpack_public_path__ + "images/bmo-dancing-1daf51f.gif";